<ces-asset-breadcrumb [trail]="breadcrumbTrail()" />

<div cesFullscreen #fs="cesFullscreen" class="p-(--padding-card) pt-(--space-2) flex flex-col flex-1 min-h-0">
  <div class="flex justify-between items-start gap-(--space-4) mb-(--space-2)">
    <div class="flex items-center gap-(--space-2)">
      <h1 class="text-h1">{{ title() }}</h1>
      @if (externalLinkUrl()) {
        <a
          [href]="externalLinkUrl()"
          target="_blank"
          class="flex items-center justify-center w-8 h-8 border border-(color:--p-gray-200) rounded bg-white hover:border-(color:--p-gray-300)">
          <span class="material-symbols" style="font-size: 16px; color: var(--p-orange-100)">open_in_new</span>
        </a>
      }
    </div>

    <ces-date-navigation
      [startDate]="dateNav.startDate()"
      [endDate]="dateNav.endDate()"
      [canNavigate]="dateNav.canNavigate()"
      [endDateDisabled]="dateNav.endDateDisabled()"
      [refreshDisabled]="!dateNav.canNavigate()"
      (startDateChange)="dateNav.startDate.set($event)"
      (endDateChange)="dateNav.endDate.set($event)"
      (navigatePrevious)="dateNav.navigatePrevious()"
      (navigateNext)="dateNav.navigateNext()"
      (refresh)="refresh()" />
  </div>

  @if (frequencyTag()) {
    <div class="mb-(--space-4)">
      <span
        class="inline-flex items-center px-3 py-1 rounded-full text-sm whitespace-nowrap"
        style="background: var(--p-blue-100); color: var(--p-blue-300)">
        {{ frequencyTag() }}
      </span>
    </div>
  }

  <div class="flex justify-between items-center mb-(--space-2)">
    <div class="flex items-center gap-(--space-2)">
      <ng-content select="[slot=column-toggle]" />
      <ces-button-secondary icon="content_copy" [label]="copyButtonLabel()" [disabled]="copyDisabled()" (onClick)="onCopyClick()" />
      @if (selectedCellCount() > 0) {
        <ces-button-secondary icon="close" [label]="'common.buttons.clearSelection' | transloco" (onClick)="clearSelection()" />
      }
      <ng-content select="[slot=actions]" />
    </div>
    <div class="flex items-center gap-(--space-2)">
      @if (hasActiveFilters()) {
        <ces-button-secondary icon="filter_alt_off" [label]="'common.buttons.clear' | transloco" (onClick)="clearAllFilters()" />
      }
      <ces-button-secondary
        [icon]="fs.isFullscreen() ? 'fullscreen_exit' : 'fullscreen'"
        [attr.aria-label]="(fs.isFullscreen() ? 'common.buttons.exitFullscreen' : 'common.buttons.fullscreen') | transloco"
        (onClick)="fs.toggle()" />
    </div>
  </div>

  @if (showStaleWarning()) {
    <div role="status" class="flex justify-center items-center px-2 py-1 mb-(--space-2) bg-(color:--p-surface-50) rounded">
      <span class="text-[13px] text-(color:--text-secondary)">{{ 'tables.data.staleWarning' | transloco }}</span>
    </div>
  }

  @if (isLoading()) {
    <ces-grid-skeleton
      [lines]="10"
      [columns]="['', '', '', '', '']"
      [widths]="['8rem', '', '', '', '']"
      [heights]="['1.5rem', '1.5rem', '1.5rem', '1.5rem', '1.5rem']" />
  } @else if (loadError()) {
    <div
      role="alert"
      aria-live="assertive"
      class="flex flex-col items-center justify-center py-(--space-8) text-center bg-(color:--p-surface-50) rounded-(--radius-md)">
      <i class="pi pi-exclamation-triangle text-4xl text-(color:--p-red-500) mb-(--space-3)" aria-hidden="true"></i>
      <p class="text-(color:--text-primary) font-medium mb-(--space-2)">{{ 'tables.data.loadError.title' | transloco }}</p>
      <p class="text-(color:--text-secondary) text-sm">{{ 'tables.data.loadError.hint' | transloco }}</p>
    </div>
  } @else if (showNeedsRefresh()) {
    <div class="flex flex-col items-center justify-center py-(--space-8) text-center bg-(color:--p-surface-50) rounded-(--radius-md)">
      <i class="pi pi-refresh text-4xl text-(color:--p-primary-color) mb-(--space-3)" aria-hidden="true"></i>
      <p class="text-(color:--text-primary) font-medium mb-(--space-2)">{{ 'tables.data.needsRefresh.title' | transloco }}</p>
      <p class="text-(color:--text-secondary) text-sm">{{ 'tables.data.needsRefresh.hint' | transloco }}</p>
    </div>
  } @else if (isReady()) {
    <ag-grid-angular
      [localeText]="localeText"
      class="ag-theme-quartz w-full flex-1 min-h-[180px]"
      [style.height]="fs.isFullscreen() ? 'calc(100vh - 80px)' : null"
      [columnDefs]="columnDefs()"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      [rowSelection]="rowSelection()"
      [rowClassRules]="rowClassRules()"
      (gridReady)="onGridReady($event)"
      (cellSelectionChanged)="onCellSelectionChanged()"
      (selectionChanged)="onSelectionChanged()" />
  }
</div>
